/**
 * SpecialNotes - Special instructions textarea
 */
import { memo } from 'react';
import { Textarea } from '../ui/textarea';

const SpecialNotes = memo(function SpecialNotes({ 
  value, 
  onChange 
}) {
  return (
    <div>
      <h4 className="font-medium text-base mb-2">Special Instructions (optional)</h4>
      <Textarea
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder="Any allergies or special requests..."
        className="rounded-xl text-sm min-h-[60px]"
        rows={2}
        data-testid="special-notes-input"
      />
    </div>
  );
});

export default SpecialNotes;
